type DownloadOption = {
    name: string
    modifier: string
    format: string
    type: string
}

type WidgetState = {
    assets: unknown[]
    params: { span: string }
    widget: unknown
}

export default async function downloadOptionsForWidget(
    widgetConfig: LiveWidgetConfig,
    widgetState: WidgetState,
    defaultOptions = []
): Promise<unknown[]> {
    // The following config applies only to depth message widgets
    if (widgetState.widget?.jsonConfig?.spanPicker?.type !== 'depth') {
        return [defaultOptions, []]
    }

    const omitTmst = '(omitTimestamp)'
    const indexField = '(indexField=index_depth)'

    const newOptions = [
        makeOption('CSV', 'Plain', 'csvPlus' + indexField + omitTmst, 'csv'),
        makeOption('CSV', 'GZip', 'csvPlus' + indexField + omitTmst + '.gzip', 'csv.gzip'),
        makeOption('CSV', 'ZIP', 'csvPlus' + indexField + omitTmst + '.zip(single)', 'csv.zip'),

        makeOption('JSON', 'Plain', 'jsonPlus', 'json'),
        makeOption('JSON', 'GZip', 'jsonPlus' + '.gzip', 'json.gzip'),
        makeOption('JSON', 'ZIP', 'jsonPlus' + '.zip(single)', 'json.zip'),

        makeOption('Excel', 'Plain', 'excelPlus' + indexField + omitTmst, 'excel'),
        makeOption('Excel', 'GZip', 'excelPlus' + indexField + omitTmst + '.gzip', 'excel.gzip'),
        makeOption('Excel', 'ZIP', 'excelPlus' + indexField + omitTmst + '.zip(single)', 'excel.zip')
    ]

    return [newOptions, []]
}

function makeOption(name, modifier, format, type): DownloadOption {
    return { name, modifier, format: format, type }
}
